import { render, staticRenderFns } from "./ProfileNotePage.vue?vue&type=template&id=5ac42f36&"
import script from "./ProfileNotePage.vue?vue&type=script&lang=js&"
export * from "./ProfileNotePage.vue?vue&type=script&lang=js&"
import style0 from "./ProfileNotePage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports